import { Email } from "@mui/icons-material";
import {
    Box,
    Typography
} from "@mui/material";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { MenuButton } from "src/theme/StyledFields";
import { useAppContext } from "../context/AppContext";
import { useNativeWebViewInsets } from "../context/NativeWebViewInsetsContext";
import Logo from "../theme/Logo";
import { ThemeContext } from "../theme/ThemeContext";
import { nativeInsetSx } from "../utils/nativeWebViewInsets";
import RoleBasedMenu from "./RoleBasedMenu";
import { isSMSPDomain } from "./menus/PublicPagesMenu";

const Footer: React.FC = () => {
    const { organization } = useAppContext();
    const { brandingSettings } = useContext(ThemeContext);
    const nativeInsets = useNativeWebViewInsets();
    const isSMSP: boolean = isSMSPDomain();

    // Get organization display name
    const orgDisplayName = brandingSettings?.organizationName ||
        organization?.short_name ||
        organization?.name || 'Strong Mind Strong Performance';

    return (
        <Box
            id="main-footer"
            sx={{
                borderTop: 1,
                borderColor: 'divider',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                color: 'white',
                ...nativeInsetSx(nativeInsets, "horizontal"),
            }}
        >
            {/* Brand row */}
            <Box
                sx={{
                    px: 2,
                    py: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: { xs: 'center', md: 'flex-start' },
                    background: '#1c1c1c',
                }}
            >
                <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                        ml: 1,
                        fontWeight: 'bold',
                        color: 'white',
                    }}>
                        {isSMSP ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'center', md: 'flex-start' } }}>
                                <Logo height={40} variant="dark" />
                                <Typography
                                    variant="caption"
                                    component="div"
                                    sx={{
                                        m: 0,
                                        mt: 0.5,
                                        p: 0,
                                        fontSize: '0.7rem',
                                        opacity: 0.8
                                    }}
                                >
                                    © {new Date().getFullYear()} Strong Mind Strong Performance
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                                    <Logo height={40} />
                                    <Typography
                                        variant="h6"
                                        component="div"
                                        sx={{ m: 0, p: 0, lineHeight: 1.2 }}
                                    >
                                        {orgDisplayName}
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.5 }}>
                                    <Typography
                                        variant="caption"
                                        component="span"
                                        sx={{
                                            m: 0,
                                            p: 0,
                                            fontSize: '0.7rem',
                                            opacity: 0.8,
                                            mr: 0.5
                                        }}
                                    >
                                        powered by
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        component="span"
                                        sx={{
                                            m: 0,
                                            p: 0,
                                            fontSize: '0.7rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Strong Mind Strong Performance © {new Date().getFullYear()}
                                    </Typography>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </Link>
            </Box>

            {/* Menu row */}
            <Box
                sx={{
                    px: 2,
                    py: 2.5,
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 1,
                    justifyContent: { xs: 'center', md: 'flex-end' },
                    background: '#111111',
                }}
            >
                <RoleBasedMenu layout="footer" />
            </Box>

            {/* Contact row */}
            <Box
                sx={{
                    px: 2,
                    py: 2.5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: { xs: 'center', md: 'flex-end' },
                    background: '#000000',
                    ...(nativeInsets.isNativeWebView && nativeInsets.paddingBottom > 0
                        ? { paddingBottom: (theme) => `calc(${theme.spacing(1)} + ${nativeInsets.paddingBottom}px)` }
                        : {}),
                }}
            >
                <MenuButton
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<Email fontSize="small" />}
                    component={Link}
                    to="/contact"
                >
                    Contact Us
                </MenuButton>
            </Box>
        </Box>
    );
};

export default Footer;
